import { CartLine, OrderTypes } from '@next/core-lib/cart';
import { createAction, props } from '@ngrx/store';

export const deleteLineFromCartConfirmation = createAction('[App] Delete cart line from cart confirmation', props<{ cartId: number; cartLineId: string }>());

export const deleteCartConfirmation = createAction(
  '[App] Delete cart confirmation',
  props<{ cartId: number; returnUrl?: string; returnApplicationNameKey?: string }>(),
);

export const openDeliveryDateDialog = createAction(
  '[App] Open delivery date dialog',
  props<{ cartIdentifier: number; cartLine: CartLine; orderType?: OrderTypes }>(),
);

export const openSiloDialog = createAction('[App] Open silo dialog', props<{ cartIdentifier: number; cartLine: CartLine }>());

export const openProductSupplementDialog = createAction('[App] Open product supplement dialog', props<{ cartIdentifier: number; cartLine: CartLine }>());

export const openRemarksDialog = createAction('[App] Open remarks dialog', props<{ cartId: number; cartLine: CartLine }>());

export const openRemarksDialogDialogSuccess = createAction('[App]  Open remarks dialog success');

export const errorHappened = createAction('[Cart] Error happened', props<{ translatedValidationMessages: string[] }>());
